<template>
    <div class="col-lg-6">
        <div class="card alert">
            <div class="row">
                <div class="col-lg-4">
                    <div class="product-3-img">
                        <img v-bind:src="item['img']"/>
                    </div>
                </div>

                <div v-if="editMode" class="col-lg-8">
                    <div class="product_details_3">
                        <div class="product_name">
                            <input v-model="title" :placeholder="'Título'">

                        </div>
                        <div class="product_des">
                            <input v-model="description" :placeholder="'Descripción'">
                            <input v-model="cost" :placeholder="'Precio'">
                        </div>
                        <div class="prdt_add_to_cart">
                            <button type="button" class="btn btn-success btn-rounded" @click="updateItem">Guardar</button>
                            <button type="button" class="btn btn-primary btn-rounded" @click="editMode=false">Cancelar</button>
                        </div>
                    </div>
                </div>

                <div v-else class="col-lg-8">
                    <div class="product_details_3">
                        <div class="product_name">
                            <h4>{{ item['title'] }}</h4>

                        </div>
                        <div class="product_des">
                            <p>{{ item['description'] }}</p>
                            <p>${{ item['cost'] }}</p>
                        </div>
                        <div class="prdt_add_to_cart">
                            <button type="button" class="btn btn-success btn-rounded" @click="editMode = true">Editar</button>
                            <button type="button" class="btn btn-primary btn-rounded  m-l-5" @click="$emit('delete-item',[section,index])">Eliminar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div><!-- /# card -->
    </div><!-- /# column -->
</template>
<script>
import firebase from 'firebase'
import router from "@/router.js";

export default {
    props:{
        item: Object,
        section: String,
        index: Number
    },
    data(){
        return{
            editMode: false,
            title: "",
            description: "",
            cost: ""
        }
    },
    methods:{
        updateItem: function(){
            const db = firebase.firestore()
            var restRef = db.collection('restaurants').doc('1001');

            restRef.update({
                ['menu.' + this.section + '.' + this.index + '.title' ]: this.title,
                ['menu.' + this.section + '.' + this.index + '.description' ]: this.description,
                ['menu.' + this.section + '.' + this.index + '.cost' ]: this.cost

            }).then(() => {
                this.editMode = false
                this.$parent.retrieveMenu()
            })
        }
    }
}
</script>
